import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import AuthLayout from '../components/AuthLayout';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

const SignUpPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        phone: ''
    });
    const [loading, setLoading] = useState(false);
    const { register } = useAuth();
    const navigate = useNavigate();

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSendOtp = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            // 1. Send OTP Request
            await api.post('/auth/send-otp', { email: formData.email, type: 'register' });

            setLoading(false);

            // 2. Prompt for OTP
            const { value: otp } = await Swal.fire({
                title: 'Enter Verification Code',
                text: `We have sent a code to ${formData.email}`,
                input: 'text',
                inputPlaceholder: '_ _ _ _ _ _',
                showCancelButton: true,
                confirmButtonColor: '#10B981',
                cancelButtonColor: '#EF4444',
                inputValidator: (value) => {
                    if (!value) return 'You need to write the code!';
                }
            });

            if (otp) {
                verifyAndRegister(otp);
            }

        } catch (err) {
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: err.response?.data?.message || 'Failed to send OTP',
                confirmButtonColor: '#10B981'
            });
        }
    };

    const verifyAndRegister = async (otp) => {
        setLoading(true);
        try {
            // 3. Register with OTP
            await register({ ...formData, otp });

            setLoading(false);

            await Swal.fire({
                icon: 'success',
                title: 'Welcome!',
                text: 'Account created successfully',
                confirmButtonColor: '#10B981',
                timer: 2000
            });

            navigate('/patient-dashboard');

        } catch (err) {
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: 'Registration Failed',
                text: err.response?.data?.message || 'Invalid Request',
                confirmButtonColor: '#10B981'
            });
        }
    };

    return (
        <AuthLayout title="Create Account" subtitle="Join Medoro as a Patient">
            <form onSubmit={handleSendOtp}>
                <div className="form-group">
                    <label className="form-label">Full Name</label>
                    <input
                        type="text"
                        name="name"
                        className="form-input"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="John Doe"
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">Email Address</label>
                    <input
                        type="email"
                        name="email"
                        className="form-input"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        placeholder="name@example.com"
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">Phone Number</label>
                    <input
                        type="tel"
                        name="phone"
                        className="form-input"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        placeholder="+91 234 567 8900"
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">Password</label>
                    <input
                        type="password"
                        name="password"
                        className="form-input"
                        value={formData.password}
                        onChange={handleChange}
                        required
                        placeholder="••••••••"
                    />
                </div>

                <button
                    type="submit"
                    className="btn btn-primary w-full"
                    disabled={loading}
                    style={{ opacity: loading ? 0.7 : 1 }}
                >
                    {loading ? 'Processing...' : 'Verify & Sign Up'}
                </button>

                <div className="mt-4 text-center" style={{ fontSize: '0.9rem' }}>
                    <span style={{ color: 'var(--text-secondary)' }}>Already have an account? </span>
                    <Link to="/login" style={{ color: 'var(--primary-color)', fontWeight: 500 }}>Sign in</Link>
                </div>
            </form>
        </AuthLayout>
    );
};

export default SignUpPage;
